import { render, staticRenderFns } from "./AddProduct.vue?vue&type=template&id=424cb8f5&scoped=true&"
import script from "./AddProduct.vue?vue&type=script&lang=js&"
export * from "./AddProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424cb8f5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('424cb8f5')) {
      api.createRecord('424cb8f5', component.options)
    } else {
      api.reload('424cb8f5', component.options)
    }
    module.hot.accept("./AddProduct.vue?vue&type=template&id=424cb8f5&scoped=true&", function () {
      api.rerender('424cb8f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Modal/AdminPage/ProductsPage/AddProduct.vue"
export default component.exports